// Copyright (C) 2017-2022 Smart code 203358507

const HorizontalNavBar = require('./HorizontalNavBar');

module.exports = HorizontalNavBar;
